var BookActionSection = require("components/reading/books/BookActionSection");
var BookActionModal = require("components/reading/books/BookActionModal");
var CurrentUser = require("lib/account/CurrentUser");
var DateSpanSelector = require("components/data/DateSpanSelector");

var Features = require("lib/account/Features");
var Glyphicon = require("components/utility/icons/Glyphicon");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var Spinner = require("components/utility/Spinner");
var StudentMetrics = require("lib/data/StudentMetrics");
var StudentProgressDisplay = require("components/users/students/StudentProgressDisplay");
var SaleModal = require("components/games/SaleModal");
var NewItemsModal = require("components/games/NewItemsModal")
var ShopSales = require("lib/games/ShopSales");
var StudentTasks = require("components/users/students/StudentTasks");
var StudentActivities = require("components/users/students/StudentActivities");
var GamifiedStudentDisplay = require("components/users/students/GamifiedStudentDisplay");
var LogReadingModal = require("components/reading/books/LogReadingModal")
var StudentOnboardingModal = require("components/users/students/onboarding/StudentOnboardingModal");

var NewYearSaleBanner = require('misc/new-year-sale-banner.png')

var ReactTooltip = require("react-tooltip");

var moment = require("moment");
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { Scrollbars } from 'react-custom-scrollbars';
import _ from "underscore";


require("users/students/student_home_page_vertical.scss");
require("users/students/student_progress_display.scss");


@connect(
  (state, props) => ({
    student: RosterSelectors.student({ state, id: props.match.params.id }),
    showLogReading: Features.isEnabled(Features.LOG_READING),
    showExercises: Features.isEnabled(Features.DIGITAL_EXERCISES),
    showQuestionBuilders: CurrentUser.get().prefs.display_question_builder || false,
    validTasks: WritingSelectors.validStudentHomepageTasks({ state, conditions: { userID: CurrentUser.get().id } }),

    hasTasks: RosterSelectors.studentTaskCount({ state, studentID: props.match.params.id }) > 0,
    hasRevisables: _.size(ReadingSelectors.booksWithRevisables({ state, conditions: { userID: CurrentUser.get().id } })) > 0,
    standaloneEssayRevisions: WritingSelectors.essayAnswers({ state, filters: { allow_revision: true } }).filter(a => !a.text_id),
  }),
  (dispatch, props) => ({
    populateData: (startDate, endDate) => {
      var studentID = props.match.params.id;

      var fetchStudent = () => {
        if (CurrentUser.hasID(studentID)) {
          var embeds = [
            "student.expectations_progress", "student.prefs",
            "student.expectations_date_spans", "student.perks",
            "student.is_clickable_egg", "all_tasks", "task.task_items"
          ];

          embeds = embeds.concat([
            "task.subject", "activity.format_summary"
          ]);

          if (Features.isEnabled(Features.CLOZE_ASSESSMENTS)) {
            embeds = embeds.concat([
              "student.cloze_status"
            ]);
          }
        }
        var studentQuery = {};
        if (startDate) {
          studentQuery.expectations_progress_start_date = startDate;
        }
        if (endDate) {
          studentQuery.expectations_progress_end_date = endDate;
        }

        return dispatch(RosterActions.fetchStudent({
          id: studentID, query: studentQuery,
          embeds: embeds
        }))
      }

      // We fetch it here because we need to know if there are pending tasks
      //   (RosterSelectors.studentTaskCount)
      // We actually select the books in StudentTasks
      var fetchRevisables = () => {
        var filters = {
          user_id: studentID,
          revisable: true
        }
        var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];

        return dispatch(ReadingActions.fetchBookActivity({
          filters, embeds, cache: true
        }))
      }

      var fetchEssayRevisions = () => dispatch(WritingActions.fetchAnswers({ filters: { allow_revision: true } }));

      var promises = [fetchStudent(), fetchRevisables(), fetchEssayRevisions()];

      return Promise.all(promises);
    },
    postBooks: (book, callback) => {
      CurrentUser.api().postBooks({ book: book }, $wr.apiHandler((response) => {
        callback(response.book)
      }));
    },
  })
)
@providePopulateData({ waitForLoad: true })
class StudentHomePageVertical extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    this.state = {
      showFindBookSection: false,
      openActivityType: null,
      selectedActivityID: null,
      logReadingSelectedBook: null,
      showLogReadingModal: false,
      showNewItemsModal: false
    }
    this.actionModal = React.createRef()
  }

  /////// STUDENT HELPERS ///////

  getStudentGradeLevel() {
    var { student } = this.props
    return student && student.grade_level ? parseInt(student.grade_level) : 5
  }

  studentLoading() {
    var { student, loadingStudent } = this.props
    return loadingStudent || !student || !student.prefs ||
      !student.expectations_progress || !student.expectations_date_spans
  }

  sortedStudentExpecations() {
    var { student } = this.props
    var grade_level = this.getStudentGradeLevel()

    var expectations = _.filter(student.prefs.grade_level_expectations_metrics[grade_level], (e) => { return e.goal !== 0 });
    return _.sortBy(expectations, (e) => {
      return e.metric == StudentMetrics.TYPES.QUIZZES_PASSED ? "AAA" : e.metric
    })
  }

  studentActions() {
    var { showLogReading, showQuestionBuilders, showExercises } = this.props

    var metricsOnly = _.pluck(this.sortedStudentExpecations(), 'metric');
    var actions = [StudentMetrics.TYPES.QUIZZES_PASSED, StudentMetrics.TYPES.QUESTIONS, StudentMetrics.TYPES.REVIEWS]

    // add reading logs
    if (showLogReading) {
      if (!_.contains(metricsOnly, "minutes") && !_.contains(metricsOnly, "pages")) {
        actions.push("minutes")
      }
    }

    // add question builders
    if (showQuestionBuilders) {
      actions.push(StudentMetrics.TYPES.QUESTION_BUILDER)
    }

    if (showExercises) {
      actions.push("exercises");
    }
    
    // only want third grade and up to get these
    if (this.getStudentGradeLevel() >= 3){
      actions.push(StudentMetrics.TYPES.ESSAYS)
    }
    
    var freeActions = _.reject(actions, (action) => {
      return _.contains(metricsOnly, action);
    });

    return { actions, freeActions }
  }
  ////////////////////////////


  openBookSearch(activityType, activityID, textProvided) {
    if (textProvided) {
      var redirectURL = "/responses/new?text_id=&activity_id=" + activityID;
      $wr.redirect(redirectURL);
    } else {
      this.setState({ openActivityType: activityType, showFindBookSection: true, selectedActivityID: activityID }, function () {
        $wr.scrollToElement($(this.refs.container).find(".bookActionSection"), 100)
      }.bind(this))
    }
  }

  openBookActivity(activityType, book, isFirst) {
    var goToActivity = function (selBook) {
      if (isFirst) {
        var firstParam = "&first=true";
      } else {
        var firstParam = "";
      }

      if (activityType == "quiz") {
        $wr.redirect("/quiz?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "question") {
        $wr.redirect("/answers/new?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "question_builder") {
        $wr.redirect("/question_builder/new?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "review") {
        $wr.redirect("/reviews/new?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "exercise") {
        var redirectURL = "/responses/new?text_id=" + selBook.text_id + firstParam;
        if (this.state.selectedActivityID != null) {
          redirectURL += "&activity_id=" + this.state.selectedActivityID;
        }
        $wr.redirect(redirectURL);

      } else if (activityType == "log") {
        this.setState({ logReadingSelectedBook: book }, () => {
          this.setState({ showLogReadingModal: true });
        });

      } else {
        throw "Unknown activity type: " + activityType;
      }
    }.bind(this);

    if (book.text_id) {
      goToActivity(book);
    } else {
      this.props.postBooks(book, goToActivity)
    }
  }

  hideOwls() {
    var user = CurrentUser.get();
    return user.settings && user.settings.hide_owls;
  }
  recentlyCreated() {
    moment(CurrentUser.get().created_at) < moment().subtract(2, "days");
  }

  startDate() {
    var dateSpans = this.props.student.expectations_date_spans;
    return this.state.startDate || dateSpans[0].start
  }
  endDate() {
    var dateSpans = this.props.student.expectations_date_spans;
    return this.state.endDate || dateSpans[0].end
  }

  changeDates(startDate, endDate) {
    this.setState({ startDate, endDate, showFindBookSection: false }, () => {
      this.props.populateData(startDate, endDate)
    });
  }

  isMatchingDateSpan() {
    if (this.props.student && this.props.student.expectations_date_spans) {
      return _.filter(this.props.student.expectations_date_spans, (span) => {
        return (span.start == this.startDate()) && (span.end == this.endDate());
      }).length > 0;
    }
    return false
  }

  showArrow() {
    var progressMade = _.map(this.props.student.expectations_progress, (value) => {
      if (value > 0) {
        return true;
      } else {
        return false;
      }
    })
    return !_.contains(progressMade, true)
  }

  renderDateSelectors() {
    if (this.props.student && this.props.student.expectations_date_spans) {
      var dateSpans = this.props.student.expectations_date_spans;
      return (
        <div className="dateSpanSelectorWrap">
          <DateSpanSelector startDate={this.startDate()} endDate={this.endDate()}
            expectationsSpans={dateSpans}
            onSelectDates={this.changeDates} />
        </div>
      );
    }
  }

  onPickSelect(book) {
    this.setState({ selectedBook: book })
    this.actionModal.current.show();
  }

  renderDividerSection(title) {
    return (
      <div className="subTitleContainer">
        <div className="nameArea">
          <span className="nameString subHeader">
            {title}
          </span>
        </div>
      </div>
    );
  }

  closeLogReading() {
    this.setState({ showLogReadingModal: false, logReadingSelectedBook: null });
  }

  readingLogModal() {
    return (
      <LogReadingModal
        initialBook={this.state.logReadingSelectedBook}
        open={this.state.showLogReadingModal} onClose={this.closeLogReading}
        key={_.pluck(this.state.logReadingSelectedBook, 'text_id')} />
    )
  }
  showActivitiesColumn() {
    return this.props.hasRevisables ||
      (this.props.hasTasks && this.props.validTasks.length) ||
      (this.props.standaloneEssayRevisions && this.props.standaloneEssayRevisions.length > 0)
  }

  /////// RENDER FUNCTIONS ///////

  renderOnboardingModal() {
    var { student } = this.props
    if (student && (student.pending_onboarding || student.pending_onboarding === null)) {
      return <StudentOnboardingModal />;
    }
  }

  renderSpinner() {
    return <div><Spinner placeholder={true} scale={1.7} /></div>
  }


  renderGoalPeriodProgress() {
    var { student } = this.props
    var progress = student.expectations_progress;

    var expectations = this.sortedStudentExpecations()
    var actions = this.studentActions()['actions']

    if ((expectations || []).length || (student.cloze_status || {}).trigger) {
      var progressDisplay = _.map(expectations, (expectation) => {
        var metric = expectation.metric;
        var actionMetric = metric == "days-active" ? "questions" : metric;
        var onClick = metric == StudentMetrics.TYPES.ESSAYS ? () => { $wr.redirect("/essays/new") } : this.openBookSearch.bind(this, actionMetric, null, false)
        return (
          <a onClick={onClick}
            key={metric}>
            <StudentProgressDisplay
              metric={metric}
              title={StudentMetrics.getLabel(metric)}
              unit={StudentMetrics.getUnit(metric)}
              total={expectation.goal}
              current={progress[metric]}
              actionLabel={StudentMetrics.getActionLabel(metric)}
              openBookSearch={this.openBookSearch.bind(this, actionMetric, null, false)} />
          </a>
        );
      });
      if (student.cloze_status && student.cloze_status.trigger) {
        var rld = student.cloze_status;
        var metric = "challenges";
        var rldProgressDisplay = (
          <a onClick={this.openChallenges} href="/cloze"
            key={metric}>
            <StudentProgressDisplay
              metric={metric}
              title={StudentMetrics.getLabel(metric)}
              unit={StudentMetrics.getLabel(metric)}
              current={rld.current}
              total={rld.target}
              actionLabel="" />
          </a>
        )
        progressDisplay.push(rldProgressDisplay)
      }
      return progressDisplay
    } else {
      actions.shift()
      var quizAction = StudentMetrics.TYPES.QUIZZES_PASSED;
      return (
        <div className="leftContainer">
          <p>Take a Quiz!</p>
          <a onClick={this.openBookSearch.bind(this, quizAction, null, false)} key={quizAction}>
            <img src={require("action-icons/quizzes-passed-lg.png")} className="" />
          </a>
        </div>
      )
    }
  }

  renderGenericProgressDisplay() {
    var { student } = this.props
    var progress = student.expectations_progress;
    return _.map(progress, (amount, metric) => {
      if (metric == "pages") {
        var imageMetric = "minutes";
      } else if (metric == "days-active") {
        var imageMetric = "questions";
      } else {
        var imageMetric = metric;
      }
      return (
        <span className="regularContainer" key={metric}>
          <span className="amount">{amount}</span>
          <p className="metric">{StudentMetrics.getLabel(metric)}</p>
          <img src={StudentMetrics.getIcon(imageMetric)} className="metricIcon" />
        </span>
      );
    });
  }

  renderLinks() {
    var { student } = this.props
    var grade_level = this.getStudentGradeLevel()
    var expectations = student.prefs.grade_level_expectations_metrics[grade_level]

    var linksDisplay = _.map(this.studentActions()['freeActions'], (freeAction) => {
      if (USE_LABELS.includes(freeAction)) {
        var iconLable = $wr.capitalize(StudentMetrics.getLabel(freeAction))
      } else {
        var iconLable = $wr.capitalize(StudentMetrics.getUnit(freeAction))
      }

      // only want to show essay option to third grade and up
      if (freeAction == 'essays'){
        var dataTip = (
          <ReactTooltip >
            Write an essay to recieve up to 500 coins!
          </ReactTooltip>
        )
        return (
          <a onClick={()=>$wr.redirect("/essays/new")} className='goldLink' data-tip>
            <img src={StudentMetrics.getIcon(freeAction)} className="essayImg" />
            {iconLable}
            <img className='essayCoin' src={require("official-icons/coin.png")}/>
            {dataTip}
          </a>
        )
      }
      return (
        <a onClick={this.openBookSearch.bind(this, freeAction, null, false)} key={freeAction}>
          <img src={StudentMetrics.getIcon(freeAction)} className="" />
          {iconLable}
        </a>
      )
    })

    if ((expectations || []).length || (student.cloze_status || {}).trigger) {
      return (
        <div className={'linksContainer'}>
          {linksDisplay}
        </div>
      )
    } else {
      return (
        <div className={'emptyStateLinks'}>
          <p>Other Things to Do</p>
          {linksDisplay}
        </div>
      )
    }
  }

  renderBookSearch() {
    if (this.state.showFindBookSection) {
      if (this.showActivitiesColumn()) {
        return (
          <div>
            <BookActionSection sectionDividerHeader={true}
              openBookActivity={this.openBookActivity}
              studentDashboard={true}
              openActivityType={this.state.openActivityType} />
          </div>
        )
      }
      else {
        return (
          <BookActionSection openBookActivity={this.openBookActivity}
            studentDashboard={true}
            openActivityType={this.state.openActivityType} />
        )
      }
    }
  }

  renderTaskContainer() {
    var { student } = this.props

    if (student && this.showActivitiesColumn()) {
      return (
        <StudentActivities openBookActivity={this.openBookActivity} onPickSelect={this.onPickSelect}
          onActivitySelect={this.openBookSearch.bind(this, "exercises")} />
      );
    }
  }

  renderSale() {
    var saleModal = null
    var saleBanner = null
    
    if (ShopSales.hasCurrentSale() && !this.hideOwls() && !this.recentlyCreated()) {
      var saleModal = (
        <SaleModal ref="saleModal" saleData={ShopSales.getCurrentSale()} />
      );

      var banner = ShopSales.getSaleBanner()
      var saleBanner = (
        <div onClick={() => { this.refs.saleModal.show() }}
          className="saleBanner">
          <img src={banner} className="bannerImg" />
        </div>
      );

      return { saleModal, saleBanner }
    }
    return { saleModal, saleBanner }
  }

  renderNewItemsModal() {
    return <NewItemsModal open={this.state.showNewItemsModal} title='New Year, New Owl Shop Items!' />
  }

  renderNewItemsBanner() {
    return (
      <div onClick={() => {
        // trigger new items modal
        this.setState({ showNewItemsModal: true }, () => {
          this.setState({ showNewItemsModal: false })
        })
      }}
        className="saleBanner">
        <img src={NewYearSaleBanner} className="bannerImg" />
      </div>
    )
  }

  renderProgressDisplay() {
    if (this.studentLoading()) {
      return this.renderSpinner()
    } else if (this.isMatchingDateSpan()) {
      return this.renderGoalPeriodProgress()
    } else {
      return this.renderGenericProgressDisplay()
    }
  }

  render() {
    var { student } = this.props
    var grade_level = this.getStudentGradeLevel()    
    var expectations = student.prefs.grade_level_expectations_metrics[grade_level]
    if ((expectations || []).length || (student.cloze_status || {}).trigger) {
      var dateSelectors = this.renderDateSelectors();
    } else {
      var emptyDashboard = "emptyDashboard";
    }

    var tasksContainer = this.renderTaskContainer()
    var widerDashboard = tasksContainer ? '' : " widerDashboard";
    var studentDisplay = <GamifiedStudentDisplay student={student} />;
    var { saleModal, saleBanner } = this.renderSale()
    if (!saleBanner) {
      // var newItemsModal = this.renderNewItemsModal()
      // var newItemsBanner = this.renderNewItemsBanner()
    }

    if (this.showActivitiesColumn()) {

      return (
        <div className="studentHomePageVertical container" ref="container">
          {saleModal}{saleBanner}
          {/* {newItemsModal}{newItemsBanner} */}
          {studentDisplay}
          <div className={"dashboardContainer activitiesPresent " + emptyDashboard + widerDashboard}>
            {this.renderDividerSection('My Goals')}
            {dateSelectors}
            {this.renderProgressDisplay()}
            <div>
              {this.renderLinks()}
            </div>
          </div>
          <div className={"activitiesContainer " + emptyDashboard + widerDashboard}>
            {this.renderDividerSection('My Activites')}
            {tasksContainer}
          </div>
          {this.renderBookSearch()}
          <BookActionModal studentDashboard={true} ref={this.actionModal}
            selectedBook={this.state.selectedBook} openBookActivity={this.openBookActivity}
            expectations={student.prefs.grade_level_expectations_metrics[grade_level]} />
          {this.renderOnboardingModal()}
          {this.readingLogModal()}
        </div>
      )
    }
    else {
      return (
        <div className="studentHomePageVertical container" ref="container">
          {saleModal}{saleBanner}
          {/* {newItemsModal}{newItemsBanner} */}
          {studentDisplay}
          <div className={"dashboardContainer noActivities"}>
            {this.renderDividerSection('My Goals')}
            {this.renderProgressDisplay()}
            <div className='dateAndLinkContainer'>
              {dateSelectors}
              {this.renderLinks()}
            </div>
          </div>
          {this.renderBookSearch()}
          <BookActionModal studentDashboard={true} ref={this.actionModal}
            selectedBook={this.state.selectedBook} openBookActivity={this.openBookActivity}
            expectations={student.prefs.grade_level_expectations_metrics[grade_level]} />
          {this.renderOnboardingModal()}
          {this.readingLogModal()}
        </div>
      )
    }
  }

  componentDidMount() {
    Mycroft.newEvent({ category: "Student-Profile", action: "show-streamlined-profile" });
    // expand dropdown if url param
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var acceptableParams = ['exercises', 'quizzes-passed', 'reviews', 'questions', 'question-builder']
    var bookSearchDropdown = urlParams.get('bookSearchDropdown')
    if (bookSearchDropdown && acceptableParams.includes(bookSearchDropdown)) {
      this.openBookSearch(bookSearchDropdown, null, false, true);
    }
  }
}

var EXERCISE_TASK = "exercise-task";
var READING_TASK = "reading-task";
var ESSAY

var USE_LABELS = [StudentMetrics.TYPES.QUESTION_BUILDER]

StudentHomePageVertical.WrappedComponent.propTypes = PageStrictPropTypes({
  populateData: PropTypes.func,
  postBooks: PropTypes.func,
  student: PropTypes.object,
  showLogReading: PropTypes.bool,
  showExercises: PropTypes.bool,
  fetchLibraryPlatforms: PropTypes.func,
  validTasks: PropTypes.array,
  hasTasks: PropTypes.bool,
  showQuestionBuilders: PropTypes.bool,
  hasRevisables: PropTypes.bool,
  standaloneEssayRevisions: PropTypes.array,
});

module.exports = StudentHomePageVertical;


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentHomePageVertical.js